import React from 'react';
import PopupModal from '../PopupModal';
import "./ScheduleAppointment.scss";

export default function NextStepModal(props) {
    const {show, onHide} = props;
    return (
        <PopupModal
            show={show}
            onHide={onHide}
            isHeading={true}
            headingText="Next Steps with Protective and Covr"
            modalClasses="nextStepModal"
            headerClasses="modalHeader mb-1"
        />
    )
}


// WEBPACK FOOTER //
// ./src/components/Common/ScheduleAppointment/NextStepModal.js